export const ColorColumns = [
    "CRMField",
    "CentricField",
    "PONumber",
    "Style"
  ]